import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTimes,
  faInfoCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faCheckCircle,
  faInfo,
} from '@fortawesome/free-solid-svg-icons';

import {
  errorColor,
  errorColorDark,
  warnColor,
  warnColorDark,
  successColor,
  successColorDark,
} from '~theme';

function getIcon(type) {
  switch (type) {
    case 'INFO':
      return faInfoCircle;
    case 'WARNING':
      return faExclamationTriangle;
    case 'ERROR':
      return faExclamationCircle;
    case 'SUCCESS':
      return faCheckCircle;
    default:
      return faInfo;
  }
}

const Toast = ({ toast, remove }) => (
  <ToastWrapper toastType={toast.type}>
    <ToastIcon toastType={toast.type}>
      <FontAwesomeIcon icon={getIcon(toast.type)} />
    </ToastIcon>

    <ToastBody>{toast.message}</ToastBody>

    <RemoveToast onClick={() => remove(toast.id)}>
      <FontAwesomeIcon icon={faTimes} />
    </RemoveToast>
  </ToastWrapper>
);

function getBg(type) {
  switch (type) {
    case 'INFO':
      return '#333';
    case 'WARNING':
      return warnColor;
    case 'ERROR':
      return errorColor;
    case 'SUCCESS':
      return successColor;
    default:
      return '#333';
  }
}

function getIconColor(type) {
  switch (type) {
    case 'INFO':
      return '#999';
    case 'WARNING':
      return warnColorDark;
    case 'ERROR':
      return errorColorDark;
    case 'SUCCESS':
      return successColorDark;
    default:
      return '#999';
  }
}

const ToastWrapper = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  margin-bottom: 16px;
  border-radius: 4px;
  overflow-x: hidden;
  color: #fff;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.3);
  background-color: ${props => getBg(props.toastType)};
`;

const ToastIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 8px;
  font-size: 24px;
  color: ${props => getIconColor(props.toastType)};
`;

const ToastBody = styled.div`
  flex: 1;
`;

const RemoveToast = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 8px;
  color: #fff;
  font-size: 20px;
`;

export default Toast;
